import React, { useState } from 'react';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { resetPassword } from 'actions/auth';
import RadiusInput from 'components/common/formElements/radiusInput';
import Form from 'components/common/formElements/form';
import Robot from 'style/imgs/Backpack.svg';
import PswPopOver from 'components/common/helpers/passwordHelper';

import buttons from 'style/buttons.module.scss';
import styles from '../signUp/index.module.scss';

type PasswordData = {
  password: string;
  passwordConfirm: string;
};

type QueryParams = {
  code: string;
  email: string;
};

const RestorePassword: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { code, email } = useParams<QueryParams>();
  const [formData, setFormData] = useState<PasswordData>();
  const [password, setPassword] = useState('');

  const schema = yup.object().shape({
    password: yup
      .string()
      .min(8)
      .max(64)
      .matches(/^(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)[a-zA-Z\d]{8,64}$/)
      .required('Password is required'),
    passwordConfirm: yup
      .string()
      .oneOf([yup.ref('password'), null])
      .required(),
  });
  const { register, handleSubmit, errors } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(schema),
  });

  const onSubmit = (values: PasswordData) => {
    setFormData(values);
    const requestData = {
      newPassword: values.password,
      code: code || '',
      email: email || '',
    };
    dispatch(resetPassword(requestData));
  };

  return (
    <div className={styles.signUp}>
      <div className={styles.signUpLeft}>
        <div className={styles.robot}>
          <img src={Robot} alt="img" />
        </div>
      </div>
      <div className={styles.signUpRight}>
        {!formData ? (
          <div>
            <h1 className="deep-gray-heading">Change Password</h1>
            <div className={styles.trapezoid}>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <RadiusInput
                  variant="outlined"
                  id="password"
                  type="password"
                  label="New password"
                  name="password"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setPassword(e.target.value)
                  }
                  ref={register}
                  error={!!errors.password}
                />
                <PswPopOver password={password} target="password" />
                <RadiusInput
                  variant="outlined"
                  type="password"
                  label="Confirm new password"
                  name="passwordConfirm"
                  ref={register}
                  error={!!errors.passwordConfirm}
                />
                {/* {!!errorMessage && ( */}
                {/*  <span className="error-message">{errorMessage}</span> */}
                {/* )} */}
                <button type="submit" className={buttons.buttomPrimary}>
                  Confirm
                </button>
              </Form>
            </div>
            {/* <span className="gray-text">
              Already have account ?{' '}
              <Link className="orange-heading" to="/sign-up/">
                Sign up now
              </Link>
            </span> */}
          </div>
        ) : (
          <div>
            <h1 className="deep-gray-heading"> Password changed</h1>
            <button
              type="submit"
              className={buttons.buttomPrimary}
              style={{ width: '365px' }}
              onClick={() => history.push('/login')}
            >
              I Got It
            </button>
          </div>
        )}
        <span className="question">?</span>
      </div>
    </div>
  );
};

export default RestorePassword;
